<div class="card">
  <div class="card__header header">
    <div class="header__image">
      <img
        src="./assets/images/thank-you.svg"
        loading="lazy"
        alt="Thank You"
        class="header__image-img"
      />
    </div>

    <h2 class="header__title">Thank you for your order!</h2>

    <div class="header__order">
      <span class="header__order-key">Order: </span>
      <span class="header__order-value">#{{ orderNumber() }}</span>
    </div>

    <div class="header__notification">
      We are currently processing your order and we will email
      <span class="header__notification-email">{{ userEmail() }}</span>
      with order confirmation shorty
    </div>
  </div>

  <div class="card__content content">
    <div class="content__delivery">
      <div class="content__delivery-date delivery-date">
        <h3 class="delivery-date__title">{{ deliveryTypeLabel() }}</h3>

        <div class="delivery-date__card">
          <i class="icon icon-delivery-outline"></i>
          <div class="delivery-date__card-content">
            <span class="delivery-date__card-text">{{ parsedDeliveryDate().date }}</span>
            @if (parsedDeliveryDate().time) {
              <span class="delivery-date__card-time">{{ parsedDeliveryDate().time }}</span>
            }
          </div>
        </div>
      </div>

      <ul class="content__delivery-metadata delivery-metadata">
        @for (deliveryField of deliveryFields(); track $index) {
          @if (deliveryField.value) {
            <li class="delivery-metadata__item">
              <span class="delivery-metadata__item-key">
                {{ deliveryField.name }}
              </span>
              <span class="delivery-metadata__item-value">
                {{ deliveryField.value }}
              </span>
            </li>
          }
        }
      </ul>
    </div>

    <div class="content__payment">
      <span class="content__payment-key">Payment</span>
      <span class="content__payment-value">
        {{ paymentMethod() }}
        <!--        Chase Visa ending in {{ userCard() }}-->
      </span>
    </div>
  </div>
</div>
